import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { blogFetcher } from "../../api/requests";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function PopularPostList() {
  const [posts, setPosts] = useState();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const getSimilarPosts = async () => {
    setLoading(true);

    try {
      const res = await blogFetcher.getSimilarPosts(id);

      setPosts(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSimilarPosts();
  }, [id]);

  return (
    <>
      {posts?.results?.map((item, index) => (
        <div key={index}>
          <PostItem
            postTitle={item.title}
            publishedOn={item.published_date}
            postHref={`/blog-details/${item.id}`}
          />
          <hr />
        </div>
      ))}
    </>
  );
}

function PostItem({ postTitle, publishedOn, postHref = "#" }) {
  return (
    <>
      <a href={postHref}>
        <h6>{postTitle}</h6>
      </a>
      <p class="mb-0">
        <FontAwesomeIcon icon={faCalendar} /> {publishedOn}
      </p>
    </>
  );
}
